<template>
  <div class="channelOuter" v-if="loadModel.isLoaded === 'Y'">

    <!--活动不存在或下架时-->
    <el-result icon="info" title="提示" :subTitle="loadModel.errorTip" v-if="!activityModel.activityId">
    </el-result>
    <div v-else class="channel_contaiiconGouBlue.pngner">
      <div class="title">
        <img :src="activityModel.coverUrl" alt="coverUrl" @click="ImagePreviewEvent(activityModel.coverUrl)">
        <p>{{activityModel.activityName}}</p>
      </div>
      <ul class="sub_title">
        <!-- <li v-if="activityModel.activityType=='公开课'"><img :src="timeImg" alt="timeImg"><span>{{activityModel.activityStar | timeFilter}} ~ {{activityModel.activityEnd | timeFilter}}</span>
         </li>-->
        <li><img :src="cityImg" alt="cityImg" @click="ImagePreviewEvent(activityModel.cityImg)"><span>{{activityModel.address}}</span></li>
        <li v-if="activityModel.peopleLimit"><img :src="peopleImg" alt="peopleImg"><span>{{'限'+activityModel.peopleLimit+'人'}}</span>
        </li>
        <!--活动场次-->
        <li v-if="activityModel.activityTimeList && activityModel.activityTimeList.length>0">
          <div class="sub_title section_sub_title">
            <!--feeImg-->
            <img :src="timeImg" alt="timeIcon" @click="ImagePreviewEvent(timeImg)">
            <ul>
              <li class="activity_section_div" v-for="(item,index) in activityModel.activityTimeList" :key="index">
                <div>
                  <span>{{item.sectionStartDate}}</span>
                  <span>{{item.sectionEndDate}}</span>
                </div>
                <span v-if="activityModel.showFeeLabel && activityModel.showFeeLabel==='Y'">{{activityModel.feeLabel}}</span>
                <span class="text_red" v-else-if="activityModel.activityFee>0">
                  {{activityModel.activityId === malaysiaActivityId?'MYR':(item.currency && item.currencyAmount?item.currency:'CNY')}}
                  {{item.currency && item.currencyAmount?moneyFormat(item.currencyAmount):moneyFormat(item.newContactFee)}}</span>
                <span v-else>free</span>
              </li>
            </ul>
          </div>
        </li>
      </ul>
      <div class="channel_desc">
        <p><i>Organizer</i><span>{{activityModel.sponsor}}</span></p>
        <div style="max-width:100%;">
          <HtmlPanel class="bg-ff" v-if="activityModel.activityDescribe"
                     :url.asyc="activityModel.activityDescribe"></HtmlPanel>
          <div class="linkman">
            <p class="trapTitle"><span>———</span>&nbsp;Contacts&nbsp;<span>———</span></p>
            <div>
              <p>Name：{{activityModel.contactsName}}</p>
              <p>Phone number：<span @click="telFun()">+{{activityModel.contactsPhoneAreaCode}}-{{activityModel.contactsPhone}}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="footer">
          <button @click="handleSignFun" v-if="loadModel.status === 'A'">
            {{(activityModel.payStatus === '未付款' || activityModel.payStatus === '已退费') ? 'Pay' :
            activityModel.signStatus === '已报名' ? 'Registered' : ' Click to Register'}}
          </button>
          <button @click="handleSignFun" v-else>{{loadModel.status === 'D'?'Not available':'Event Closed'}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import shareCommon from '@/js/shareCommon.js'
  import customerService from '@/api/customerService'
  import cityIcon from '@/assets/channelNew/event_city.png'
  import feeIcon from '@/assets/channelNew/event_free.png'
  import peopleIcon from '@/assets/channelNew/event_people.png'
  import timeIcon from '@/assets/channelNew/event_time.png'
  import HtmlPanel from "../components/HtmlPanel";
  import {getUrlParam, moneyFormat} from "@/utils/utils";
  import $ from 'jquery'
  import '../../static/jquery-cookie/jquery.cookie.js'
  import Common from "../utils/common";
  import { ImagePreview,SwipeCell} from 'vant';

  export default {
    name: "channelDetail",
    data() {
      return {
        activityModel: {},
        cityImg: cityIcon,
        feeImg: feeIcon,
        peopleImg: peopleIcon,
        timeImg: timeIcon,
        activityId: '',
        type: '',
        channelId: '',
        activitySignId: '',
        network: true,//默认有网
        loadModel: {
          isLoaded: 'N',
          errorTip: null,
          status: 'A',//有效的 D已下架  E已过期
        },
        prodActivityIds: ["dec09095206b48bbbfc5125e4fc1d66b", "c535ac8517ec446d9fbe7b1504aeed42",
          "e90025ce1fa64c318566596c21339ac6", "08c2d26c69164be19bff9a1d320bdb43",
          "ac4e6d5d49e9434ab051b65fa6899dd0", "a89319f0b8004fb594cb13484d6eca02",
          "357533f8aa8c4cfb8ef8824e3f2e9c40",
          "bd37ab7f7a014a5cb9c022c4849248f5",
          "b6e18fdb7c314e548612298825b8fb0f",
          "ba4f45687e96478ba7e7514c3a994d1f",
          "e97cf6d102f74ce5bb5f0a399e1fdce0",
        ],
        testActivityIds: [
          "481ac0606dab4d4db2b9863c7c8c6300",
          "08f6204c87644b3096b6f03ec5f7d201",
          "985be476980f4baf8343fc46529fe2ea",
          "2df888d25d2a45cd8a59c3f5af185bc4",
          "68f0bee2925743caaa64f65116f28dcc",
        ],
        malaysiaActivityId: customerService.MalaysiaActivityId,//马来西亚活动id
        moneyFormat: moneyFormat,
        tt_test_id: '',
      }
    },
    components: {HtmlPanel},
    mounted() {
      console.log('mounted1')
      var vm = this;

      document.title = '活动详情';
      window.addEventListener('offline', () => {
        this.network = false
      });
      window.addEventListener('online', () => {
        this.network = true
      });
      vm.activityId = getUrlParam('activityId');
      vm.type = getUrlParam('type');
      vm.channelId = getUrlParam('channelId');
      vm.activitySignId = $.cookie(vm.activityId);
      //广告Id
      if (vm.$route.query.tt_test_id) {
        vm.tt_test_id = vm.$route.query.tt_test_id;
        $.cookie('tt_test_id', vm.tt_test_id)
      } else {
        vm.tt_test_id = $.cookie('tt_test_id')
        $.cookie('tt_test_id', '')
      }
      //  渠道id报名过的，进来直接获取
      if (!vm.activityId && vm.channelId) {
        vm.activitySignId = $.cookie(vm.channelId + '_channelId');
      }
      if (vm.channelId) {
        vm.getNewLinkContactsDetail();
      } else {
        vm.getChannelActivityDetail();
      }
    },
    methods: {
      ImageDOMContentLoaded() {
      let vm = this
      const iframe = document.getElementById('iframeId');
      console.log('iframe',iframe)
      if (iframe) {

        try {
          const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
          // 为 iframe 内部文档中的 body 添加点击事件
          iframeDoc.body.addEventListener('click', (event) => {
            const target = event.target;

            if (target.tagName === 'IMG') {
              const imgSrc = target.src;

              const imageExtensions = /\.(jpg|jpeg|png)$/i;
              let resPic = imageExtensions.test(imgSrc);
              if (resPic) {
                vm.ImagePreviewEvent(imgSrc)
              }
            }
          });
        } catch (error) {
          console.log('没有图片',)
        }
      } else {
        console.log('没有图片',)
      }
    },
    ImagePreviewEvent(url) {

      if (url) {
         try {
           ImagePreview({
                   images: [url],
                   closeable: true,
                   showIndex: false,
                   maxZoom: 20,
                 });
         } catch (error) {
           console.log('error',error)
         }
      }

    },
      //查看内容收集（广告统计）
      viewContent() {
        var vm = this;
        ttq.track('ViewContent', {
          contents: [
            {
              content_id: vm.channelId,
              content_name: vm.activityModel.activityName,
            }
          ]
        })
      },
      handleSignFun() {
        var vm = this;
        var url = window.location.href;
        if (!vm.network) {
          Common.PageOperator.showPromptMsg(vm, true, '网络连接异常，请稍后再试！', 'warning');
          return;
        }
        if (vm.activityModel.payStatus === '未付款' || vm.activityModel.payStatus === '已退费') {//支付页面
          //console.log('--vm.activitySignId--',vm.activitySignId)
          if (vm.activityModel.payStatus === '未付款') {
            // if(url.includes('//erp.bosum.com/customerActivity/')){
            //   // 正式
            //   if(vm.prodActivityIds.includes(vm.activityId)){
            //     vm.payFun(vm.activitySignId)
            //     return
            //   }
            // }else{
            //   // 测试
            //   if(vm.testActivityIds.includes(vm.activityId)){
            //     vm.payFun(vm.activitySignId)
            //     return
            //   }
            // }
            vm.payFun(vm.activitySignId)
            return
          }
          //let activityId = vm.activityId?vm.activityId:vm.activityModel.activityId
          vm.$router.push({
            path: '/signResult',
            query: {
              activityId: vm.activityId,
              type: vm.type,
              activitySignId: vm.activitySignId,
              channelId: vm.channelId
            }
          });
        } else if (vm.activityModel.signStatus === '已报名') {//报名详情页面
          vm.$router.push({
            path: '/signResult',
            query: {
              activityId: vm.activityId,
              channelId: vm.channelId,
              type: vm.type,
              activitySignId: vm.activitySignId
            }
          });
        } else if (vm.loadModel.status === 'A') {//活动正常
          var query = {
            activityId: vm.activityModel.activityId,
            coverUrl: vm.activityModel.coverUrl,
            activityName: vm.activityModel.activityName,
            type: vm.type,
          };
          if (vm.activityModel.city) {
            query.city = vm.activityModel.city;
          }
          if (vm.activityModel.address) {
            query.address = vm.activityModel.address;
          }
          if (vm.channelId) {
            query.channelId = vm.channelId;
            query.sponsor = vm.activityModel.sponsor;
          }
          if (vm.activityModel.activityType) {
            query.activityType = vm.activityModel.activityType;
          }
          if (vm.activityModel.activityTimeList) {
            let activityTimeList = vm.activityModel.activityTimeList.map(function (row) {
              return {
                sectionStartDate: row.sectionStartDate,
                sectionEndDate: row.sectionEndDate,
                activityTimeId: row.activityTimeId
              }
            });
            query.activityTimeList = encodeURIComponent(JSON.stringify(activityTimeList));
          }
          if (vm.tt_test_id) {
            query.tt_test_id = vm.tt_test_id;
          }
          vm.$router.push({path: '/signRegister', query: query});
        } else {
          Common.PageOperator.showPromptMsg(vm, true, '活动' + (vm.loadModel.status === 'D' ? '已下架' : '已结束'), 'warning');
        }
      },
      // 直接跳转支付
      payFun: function (activitySignId) {
        var vm = this;
        // if(vm.activityModel.currency=='IDR'){
        //   vm.mptPayFun(vm.activitySignId)
        //   return
        // }
        customerService.stripePay(vm, activitySignId, vm.channelId).then(function (data) {
          window.location.href = data;
        });
      },
      // mpt支付
      // mptPayFun(activitySignId){
      //   var vm = this;
      //   customerService.mptStripePay(vm,activitySignId).then(function (data){
      //     window.location.href = data;
      //   });
      // },
      getChannelActivityDetail() {
        var vm = this;
        vm.loadModel.errorTip = null;
        customerService.getChannelActivityDetail(vm, vm.activityId, vm.type, vm.activitySignId).then(function (data) {
          vm.loadModel.isLoaded = 'Y';
          if (Common.Util.isObject(data)) {
            vm.activityModel = data;
            //判断活动是否下架 & 过期 activityStar
            var now = new Date();
            var start = Common.Date.convertStrToDate(vm.activityModel.activityStar);
            if (vm.activityModel.validStatus === 'D') {//已下架
              vm.loadModel.status = 'D';
            } else if (Common.Date.compareDate(now, start) > 0) {//过期
              vm.loadModel.status = 'E';
            } else {
              vm.loadModel.status = 'A';
            }
            document.title = vm.activityModel.activityName;
            vm.initShare();
            if (vm.tt_test_id) {
              vm.viewContent();
            }

            if (vm.activityModel.activityDescribe) {
                   setTimeout(() => {
                      vm.ImageDOMContentLoaded()
                   }, 1000);
            }
          } else {
            vm.loadModel.errorTip = data;
          }
        });
      },
      getNewLinkContactsDetail() {
        var vm = this;
        vm.loadModel.errorTip = null;
        customerService.getNewLinkContactsDetail(vm, vm.channelId, vm.activitySignId).then(function (data) {
          vm.loadModel.isLoaded = 'Y';

          if (data && data.coverUrl) {
            data.coverUrl = data.coverUrl.replace('http://', 'https://');
          }
          if (data && data.activityDescribe) {
            data.activityDescribe = data.activityDescribe.replace('http://', 'https://');
          }
          console.log(['activityModel', data]);
          if (Common.Util.isObject(data)) {
            vm.activityModel = data;
            vm.activityId = data.activityId
            //判断活动是否下架 & 过期 activityStar
            var now = new Date();
            var start = Common.Date.convertStrToDate(vm.activityModel.activityStar);
            if (vm.activityModel.validStatus === 'D') {//已下架
              vm.loadModel.status = 'D';
            } else if (Common.Date.compareDate(now, start) > 0) {//过期
              vm.loadModel.status = 'E';
            } else {
              vm.loadModel.status = 'A';
            }
            document.title = vm.activityModel.activityName;
            vm.initShare();
            if (vm.tt_test_id) {
              vm.viewContent();
            }


            if (vm.activityModel.activityDescribe) {
                   setTimeout(() => {
                      vm.ImageDOMContentLoaded()
                   }, 1000);
            }
          } else {
            vm.loadModel.errorTip = data;
          }
          if (data.activityId == 'a6873c4a9463431996622e4d34b09cce') { // a6873c4a9463431996622e4d34b09cce,9e9314de03554b6a87e8102120169b93
            const script = document.createElement('script');
            //script.src = 'https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/transfer/bde09d6640a66193c2c99b23d8293d9e.js';
            script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','GTM-TJC9C2VV');`
            document.head.appendChild(script);
            const noscript = document.createElement('noscript');
            const iframe = document.createElement('iframe');
            iframe.src = "https://www.googletagmanager.com/ns.html?id=GTM-TJC9C2VV"
            iframe.style.height = 0;
            iframe.style.width = 0;
            iframe.style.display = 'none';
            iframe.style.visibility = 'hidden';
            noscript.appendChild(iframe);
            document.body.appendChild(noscript);
          }
        });
      },
      //初始化分享
      initShare: function () {
        var vm = this;
        var shareModel = {
          name: vm.activityModel.activityName,
          coverUrl: vm.activityModel.coverUrl,
          remarks: '【博商管理】邀请您一起参加'
        }
        shareCommon.initShare(vm, shareModel, vm.shareUrl);
      },
      //打电话
      telFun: function () {
        var vm = this;
        window.location.href = 'tel:00' + vm.activityModel.contactsPhoneAreaCode + vm.activityModel.contactsPhone;
      },
    },
    filters: {
      timeFilter(val) {
        if (val) {
          return val.substring(0, 16)
        }
        return '--'
      }
    }
  }
</script>

<style scoped>
  .channelOuter {
    background-color: #f6f6f6;
    width: 100vw;
    height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .channel_container {
    color: #676767;
    max-width: 500px;
    margin: 0 auto;
  }

  .title {
    margin-bottom: 10px;
    background: #fff;
  }

  .title > img {
    width: 100%;
    height: auto;
  }

  .title > p {
    padding: 10px 15px 15px;
    font-weight: 600;
    font-size: 16px;
    color: #000;
  }

  .sub_title {
    margin-bottom: 10px;
    background: #fff;
    padding: 10px;
  }

  .section_sub_title {
    padding: 0;
    display: flex;
    align-items: flex-start;
  }

  .section_sub_title > img {
    width: 20px;
  }

  .section_sub_title > ul {
    width: calc(100% - 20px);
  }

  .section_sub_title > ul > li {
    border-bottom: 1px dashed #ECECEC;
    margin-bottom: 10px;
    padding-bottom: 5px;
  }

  .section_sub_title > ul > li:last-child {
    border-bottom: none;
    margin-bottom: 0;
  }

  .text_red {
    color: #d43d3d;
    margin-right: 3px;
  }

  .activity_section_div {
    display: flex;
    justify-content: space-between;
    width: calc(100% - 40px);
  }

  .activity_section_div > div > span {
    display: block;
    color: #767676;
    line-height: 22px;
  }

  .sub_title > li {
    margin-bottom: 5px;
  }

  .sub_title > li:last-child {
    margin-bottom: 0;
  }

  .sub_title > li > img {
    width: 20px;
    vertical-align: middle;
    position: relative;
    top: -1px;
    margin-right: 5px;
  }

  .sub_title > li > span {

  }

  .channel_desc {
    background: #fff;
  }

  .channel_desc > p {
    border-bottom: 1px solid #f1f1f1;
    padding: 10px;
  }

  .channel_desc > p > i {
    font-style: normal;
    padding: 3px 5px;
    border-radius: 3px;
    margin-right: 10px;
    background-color: #d43d3d;
    color: #fff;
  }

  .footer {
    bottom: 0;
    right: 0;
    left: 0;
    min-height: 50px;
    width: 100%;
    position: fixed;
  }

  .footer > button {
    width: 100%;
    height: 50px;
    background-image: linear-gradient(#d43d3d, #d43d3d);
    border: 1px solid rgba(254, 43, 84, .2);
    text-align: center;
    color: #fff;
    font-weight: bold;
    font-size: 18px;
  }

  .linkman {
    padding-bottom: 150px;
  }

  .malaysia_div {
    max-width: 100%;
    padding: 10px;
  }

  .malaysia_div > img {
    max-width: 100%;
    height: auto !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/channelDetail.vue